(() => {
  if (window.__mhSaleEffect2026) return;
  window.__mhSaleEffect2026 = true;

  const normalizeLocale = (value) => String(value || 'en-AE').toLowerCase();
  const isArabic = (locale) => normalizeLocale(locale).startsWith('ar');

  const parseMoney = (value) => {
    const text = String(value || '')
      .replace(/[٠-٩]/g, (digit) => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
      .replace(/[۰-۹]/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
      .replace(/٫/g, '.')
      .replace(/٬/g, ',');

    const matches = text.match(/\d[\d,]*(?:\.\d+)?/g);
    return matches ? Number(matches.at(-1).replace(/,/g, '')) : NaN;
  };

  const formatMoney = (value, locale) => new Intl.NumberFormat(
    isArabic(locale) ? 'ar-AE' : 'en-AE',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ).format(value);

  const usableTemplate = (value, token, fallback) => {
    const text = String(value || '').trim();
    if (!text || /^translation missing:/i.test(text) || !text.includes(token)) return fallback;
    return text;
  };

  const ensureBadge = (media) => {
    let badge = media.querySelector('[data-mh-sale]');
    if (badge) return badge;

    badge = document.createElement('span');
    badge.className = 'ma-hawa-card__sale-badge';
    badge.dataset.mhSale = '';
    badge.hidden = true;
    badge.innerHTML = '<span aria-hidden="true">✦</span><span></span>';
    media.append(badge);
    return badge;
  };

  const ensureSaving = (priceBox) => {
    let saving = priceBox.querySelector('[data-mh-save]');
    if (saving) return saving;

    saving = document.createElement('span');
    saving.className = 'ma-hawa-card__sale-savings';
    saving.dataset.mhSave = '';
    saving.hidden = true;
    priceBox.append(saving);
    return saving;
  };

  const updateCard = (card) => {
    if (!card?.isConnected) return;

    const price = card.querySelector('[data-price]');
    const compare = card.querySelector('[data-compare-price]');
    const media = card.querySelector('.ma-hawa-card__media');
    const priceBox = card.querySelector('.ma-hawa-card__price');
    if (!price || !compare || !media || !priceBox) return;

    const shop = card.closest('ma-hawa-shop, [data-sale-badge-template]');
    const locale = shop?.dataset.locale || document.documentElement.lang || 'en-AE';
    const badgeTemplate = usableTemplate(
      shop?.dataset.saleBadgeTemplate,
      '[percent]',
      isArabic(locale) ? 'خصم [percent]%' : '[percent]% OFF'
    );
    const savingsTemplate = usableTemplate(
      shop?.dataset.saleSavingsTemplate,
      '[amount]',
      isArabic(locale) ? 'وفّرت [amount] د.إ' : 'You save AED [amount]'
    );

    const current = parseMoney(price.textContent);
    const original = parseMoney(compare.textContent);
    const active = !compare.hidden
      && Number.isFinite(current)
      && Number.isFinite(original)
      && original > current;

    const badge = ensureBadge(media);
    const saving = ensureSaving(priceBox);

    card.classList.toggle('has-mahawa-sale', active);
    badge.hidden = !active;
    saving.hidden = !active;

    if (!active) {
      badge.removeAttribute('aria-label');
      return;
    }

    const percent = Math.round(((original - current) * 100) / original);
    const amount = original - current;
    const badgeText = badgeTemplate.replace('[percent]', String(percent));
    const savingText = savingsTemplate.replace('[amount]', formatMoney(amount, locale));
    const badgeLabel = badge.lastElementChild;

    if (badgeLabel && badgeLabel.textContent !== badgeText) badgeLabel.textContent = badgeText;
    if (badge.getAttribute('aria-label') !== badgeText) badge.setAttribute('aria-label', badgeText);
    if (saving.textContent !== savingText) saving.textContent = savingText;
  };

  const pendingCards = new Set();
  let frame = 0;

  const flushCards = () => {
    frame = 0;
    pendingCards.forEach(updateCard);
    pendingCards.clear();
  };

  const queueCard = (card) => {
    if (!card) return;
    pendingCards.add(card);
    if (!frame) frame = window.requestAnimationFrame(flushCards);
  };

  const updateAll = (scope = document) => {
    if (scope.matches?.('.ma-hawa-card')) queueCard(scope);
    scope.querySelectorAll?.('.ma-hawa-card').forEach(queueCard);
  };

  const start = () => updateAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('change', (event) => {
    const card = event.target.closest?.('.ma-hawa-card');
    if (!card) return;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => queueCard(card));
    });
  });

  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  window.addEventListener('pageshow', () => updateAll());
})();
